import React from "react";
import LogoImg from "../assets/images/logo.svg";
import { Link, useLocation } from "react-router-dom";
import ChatBoat from "../shared/components/ChatBoat";
import { useEffect } from 'react';
import TwittweIcon from "../assets/icon/twitter.png"
export default function Footer() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return (
    <div className="bg-green py-7">
      <div className="container">
        <div className="grid border-bottom-1 border-white pb-3">
          <div className="col-12 lg:col-5 pr-7">
            <img src={LogoImg} alt="" />
            <p className="text-white">
              We simplify real estate visualization through digital innovation. From virtual staging to 3D rendering, we help you sell faster and smarter.
            </p>
          </div>
          <div className="col-12 lg:col-2">
            <h3 className="text-lg text-white font-medium mb-3">Service</h3>
            <ul className="list-none p-0 footer-link">
              <li>
                <Link to="/home">Home</Link>
              </li>
              <li>
                <Link to="/dashboard/services">Services</Link>
              </li>
              <li></li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          <div className="col-12 lg:col-2">
            <h3 className="text-lg text-white font-medium mb-3">Support</h3>
            <ul className="list-none p-0 footer-link">
              <li>
                <Link to="/contact">Help center</Link>
              </li>
              <li>
                <Link to="/terms-of-service" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Terms of service</Link>
              </li>
              <li>
                <Link to="/privacy-policy" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Privacy policy</Link>
              </li>
            </ul>
          </div>
          <div className="col-12 lg:col-3">
            <h3 className="text-lg text-white font-medium mb-4">
              Follow us on
            </h3>
            <ul className="list-none p-0 flex gap-3 social-icon">
              <li>
                <a
                  href="https://x.com/redchilli_ai/"
                  target="_blank"
                >
                  <img src={TwittweIcon} />
                  {/* <i className="pi pi-times"></i> */}
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/redchilliai/"
                  target="_blank"
                >
                  <i className="pi pi-instagram" />
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/redchilliproperties-ai/services/" target="_blank">
                  <i className="pi pi-linkedin" />
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/profile.php?id=61576084434747" target="_blank">
                  <i className="pi pi-facebook" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <p className="mb-0 mt-4 text-center text-white text-sm">
          Copyright © 2025 and LLC. RedChilli
        </p>
      </div>
      <ChatBoat />
    </div>
  );
}
